import React from 'react';

import { useTranslation } from 'react-i18next';
import Row from '../../../Layout/Row/Row';
import BaseProjectSummaryCardBlock from './BaseProjectSummaryCardBlock';

import './BaseProjectSummaryCardBlock.scss';
import { Destination, Destinations } from '../../../../types/Destination';

import { Project } from '../../../../types/Project';

import { CaptionModeEnum } from '../../../../types/enums/CaptionModeEnum';
import { CaptionSourceEnum } from '../../../../types/enums/CaptionSourceEnum';
import { captionLanguages } from '../../../../common/constants';


type Props = {
  heading: string;
  destinations: Destinations;
  project: Project;
};

const ProjectSummaryCardBlockLinks = ({ heading, destinations, project }: Props) => {
  const { t } = useTranslation();

  const getLanguageFromIso = (value: string): string => {
    const option = captionLanguages.find(opt => opt.value === value);
    return option ? option.text : 'Unknown language';
  };

 const sourceLanguage = getLanguageFromIso(project?.stream.sourceLanguageIsoCode);

 const captionMode = Array.isArray(project?.stream?.encoders) && project?.stream?.encoders.length > 0
                    ? project?.stream?.encoders[0].captionMode === CaptionModeEnum.Closed
                      ? t('producer.inputs.caption-mode.closed')
                      : t('producer.inputs.caption-mode.open')
                    : t('project.not-elapsed');

 const isAI = Array.isArray(project?.stream?.encoders) && project?.stream?.encoders.length > 0
                    ? project?.stream?.encoders[0].captionSource === CaptionSourceEnum.ASR
                      ? t('labels.on')
                      : t('labels.off')
                    : t('labels.off');


  return (
    <BaseProjectSummaryCardBlock heading={heading}>
      <Row
        left={t('project.links.source')}
        right={project?.stream?.streamKey || ''}
        columnClass="project-summary-card-column"
        leftClass="project-summary-card-row-title"
        rightClass="project-summary-card-row-content"
      />
      <Row
        left={t('producer.inputs.language.short-title')}
        right={sourceLanguage}
        columnClass="project-summary-card-column"
        leftClass="project-summary-card-row-title"
        rightClass="project-summary-card-row-content"
      />
      <Row
        left={t('producer.inputs.caption-mode.title')}
        right={captionMode}
        columnClass="project-summary-card-column"
        leftClass="project-summary-card-row-title"
        rightClass="project-summary-card-row-content"
      />
      <Row
        left={t('producer.inputs.asr-mode.title')}
        right={isAI}
        columnClass="project-summary-card-column"
        leftClass="project-summary-card-row-title"
        rightClass="project-summary-card-row-content"
      />
      <Row
        left={t('project.links.destination')}
        right={
          destinations.length > 0 &&
          destinations.map((destination: Destination, index: number) => (
            <p key={index} title={`${destination?.name} (${getLanguageFromIso(destination.languageIsoCode)})`}>{destination?.name} ({getLanguageFromIso(destination.languageIsoCode)})</p>
          ))
        }
        columnClass="project-summary-card-column"
        leftClass="project-summary-card-row-title"
        rightClass="project-summary-card-row-content"
      />
    </BaseProjectSummaryCardBlock>
  );
};

export default ProjectSummaryCardBlockLinks;
